import React, { useState, useRef, useEffect } from "react";
import DropDownIcon from "../../Assets/Images/CreateBatch/icon-dropdown-menu.png";
import "./dropdownapan.css";
export default function DropDown({
  width,
  label,
  selected,
  setSelected,
  options,
  customWidth,
  customTop,
  isRequired,
  style,
}) {
  const [isActive, setIsActive] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");

  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  useEffect(() => {
    // Find the label corresponding to the selected ID
    const selectedOption = options.find(option => option.id === selected);
    if (selectedOption) {
      setSelectedLabel(selectedOption.label);
    }
  }, [selected, options]);

  useEffect(() => {
    // Set the default selected label when the component mounts
    const defaultOption = options.find(option => option.id === selected);
    if (defaultOption) {
      setSelectedLabel(defaultOption.label);
    }
  }, []); // This useEffect runs only once on mount

  const handleClick = (option) => {
    setSelected(option.id);
    setIsActive(false);
    setSelectedLabel(option.label);
  };

  return (
    <div className="dropdown-NTS" style={{ width, ...style }} ref={dropdownRef}>
      <label className="dropdown-NTS-label">
        {label}
        {isRequired && <span>*</span>}
      </label>
      <div className="dropdown-NTS-btn" onClick={() => setIsActive(!isActive)}>
        {selectedLabel}
        <img src={DropDownIcon} alt="dropdown-icon" />
      </div>
      {isActive && (
        <div
          className="dropdown-NTS-content"
          style={{ width: customWidth, top: customTop }}
        >
          {options.map((option) => (
            <div
              key={option.id}
              className="dropdown-NTS-item"
              onClick={() => handleClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
